import React from 'react'
import gql from 'graphql-tag'
import { Redirect } from 'react-router'
import Layout from 'components/PrivateRoutes/Layout'
import PhotoGallery from 'shared/components/PhotoGallery'
import Query from 'shared/components/Query'
import ProductAssetRenderer from './ProductAssetRenderer'
import { Button, Menu, Dropdown } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import ZipDownloaderButton from './ZipDownloaderButton'

import 'react-image-lightbox/style.css'
import './index.css'

const BOOKINGS_DETAIL_QUERY = gql`
  query Booking($id: ID!) {
    booking(id: $id) {
      id
      estate {
        id
        streetAddress
        products {
          edges {
            node {
              id
              name
              state
              ... on AssetsBasedProduct {
                canDownloadAssets
                assets {
                  edges {
                    node {
                      id
                      ... on PhotoAsset {
                        image(size: "monitor") {
                          url
                          thumbUrl
                          width
                          height
                        }
                      }
                      ... on DocumentAsset {
                        url
                      }
                      ... on SlidesAsset {
                        editUrl
                        playerUrl
                      }
                      ... on UrlAsset {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

class BookingAssetsPage extends React.Component {
  state = {
    isFullscreen: false,
    initialImageIndex: null,
    fullscreenProduct: null,
  }

  assetClicked({ assetIndex, asset, product }) {
    // Only open gallery for photo assets
    if (asset.__typename === 'PhotoAsset') {
      this.setState({
        isFullscreen: true,
        initialImageIndex: assetIndex,
        fullscreenProduct: product,
      })
    }
  }

  closeFullscreen = () => {
    this.setState({ isFullscreen: false })
  }

  renderProductAssets = (product) => {
    const assets = product.assets ? product.assets.edges : []
 
    if (!assets.length || !['delivered', 'awaiting_approval'].includes(product.state)) {
      return <div>Venter på leveranse</div>
    }

    return (
      <ProductAssetRenderer
        product={product}
        onAssetClick={this.assetClicked.bind(this)}
      />
    )
  }

  getGalleryImages = (products) => {
    const fullscreenGallery = products.find(
      (p) => p === this.state.fullscreenProduct
    )

    return fullscreenGallery.assets.edges
      .map(({ node }) => node)
      .filter((n) => n.image)
      .map((n) => n.image.url)
  }

  render() {
    const { isFullscreen, initialImageIndex } = this.state

    return (
      <Query
        query={BOOKINGS_DETAIL_QUERY}
        variables={{ id: this.props.match.params.id }}
        inlineLoading
        inlineError
      >
        {({ getData }) => {
          const booking = getData('booking')

          if (!booking) {
            return <Redirect to="/bookings" />
          }

          const products = booking.estate.products.edges
            .map(({ node }) => node)
            .filter((p) => !!p.assets) // only render products that have the assets property, even if the list is empty

          return (
            <Layout {...this.props} title="Leveranse" defaultBackTo="/bookings">
              <div className="product-assets">
                {products.map((product, i) => (
                  <div className="product" key={i}>
                    <div className="heading">
                      <h2>{product.name}</h2>
                      {product.canDownloadAssets && (
                        <Dropdown
                          trigger="click"
                          overlay={
                            <Menu>
                              <Menu.Item>
                                <ZipDownloaderButton
                                  productId={product.id}
                                  size="original"
                                />
                              </Menu.Item>
                              <Menu.Item>
                                <ZipDownloaderButton
                                  productId={product.id}
                                  size="monitor"
                                />
                              </Menu.Item>
                            </Menu>
                          }
                        >
                          <Button>
                            Last ned .zip <DownOutlined />
                          </Button>
                        </Dropdown>
                      )}
                    </div>
                    {this.renderProductAssets(product)}
                  </div>
                ))}
              </div>
              {isFullscreen && (
                <PhotoGallery
                  images={this.getGalleryImages(products)}
                  initialImageIndex={initialImageIndex}
                  onCloseRequest={this.closeFullscreen}
                />
              )}
            </Layout>
          )
        }}
      </Query>
    )
  }
}

export default BookingAssetsPage
